// scope.ts — Which stored galaxy the per-planet climate/weather endpoints should read:
// the player's own sandbox galaxy (default) or a match's shared one. Set once at boot.
export const galaxyScope = { match: '' };

/** Append the match scope to a per-planet API path. */
export function scopedUrl(path: string): string {
  return galaxyScope.match ? `${path}?match=${encodeURIComponent(galaxyScope.match)}` : path;
}
